/**
 * The eval bar (unit convention §1). Mounted by `stage/Stage/View.tsx` only
 * while `analysisStore.on`, so it does not exist during a live game.
 */
import React from 'react';

import {bump} from '../renderCount';
import {useEvalBarModel} from './model';
import EvalBarView from './View';

export default React.memo(function EvalBar() {
  bump('EvalBar');
  return <EvalBarView {...useEvalBarModel()} />;
});
